module.exports = __webpack_public_path__ + "61a0bac7a80bb1af9818e33bebdb81fb.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/San_Pham.svg
// module id = ./assets/images/support-business/San_Pham.svg
// module chunks = 0